// extracted by mini-css-extract-plugin
export default {"button":"Shop_button__s4Z93","input":"Shop_input__Cfcxb","loader":"Shop_loader__ZoPOn","rotation":"Shop_rotation__MJYg-","none":"Shop_none__Oc1Uu","fill":"Shop_fill__YFmbP"};